import { useInView } from '../../../hooks/useInView';

const Historia = () => {
  const [sectionRef, inView] = useInView(0.15);
  const [textRef, textInView] = useInView(0.1);

  return (
    <section className="bg-zinc-950 py-20 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">

          {/* Image side */}
          <div
            ref={sectionRef}
            className={`relative transition-all duration-800 ${
              inView ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-10'
            }`}
          >
            <div className="aspect-[4/3] overflow-hidden border border-zinc-800">
              <img
                alt="Taller Kevin Alberto Ronda historia"
                src="https://public.readdy.ai/ai/img_res/8ec4e3d3f1ed5803996d03eb8b1c7535.jpg"
                className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
            </div>
            {/* Decorative */}
            <div className="absolute -top-4 -left-4 w-16 h-16 border-t-2 border-l-2 border-yellow-400/30 hidden lg:block" />
            <div className="absolute -bottom-4 -right-4 w-16 h-16 border-b-2 border-r-2 border-yellow-400/30 hidden lg:block" />
            <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-zinc-950 to-transparent pointer-events-none lg:hidden" />
          </div>

          {/* Text side */}
          <div
            ref={textRef}
            className={`transition-all duration-800 delay-200 ${
              textInView ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-8'
            }`}
          >
            <div className="inline-flex items-center gap-2 mb-5">
              <span className="w-5 h-px bg-yellow-400" />
              <span className="text-yellow-400 text-[10px] font-bold uppercase tracking-[0.3em]">Nuestra historia</span>
            </div>

            <h2 className="font-display text-4xl md:text-5xl uppercase text-white leading-none tracking-wide mb-6">
              Más de 8 años{' '}
              <span className="text-yellow-400">cuidando coches</span>{' '}
              en Ronda
            </h2>

            <div className="space-y-4">
              <p className="text-zinc-400 text-sm leading-relaxed font-light">
                Taller Mecánico KEVIN ALBERTO nace con una idea clara: ofrecer un servicio honesto y de calidad
                a los vecinos de Ronda y alrededores. Desde entonces, hemos ido creciendo gracias al boca a boca
                de los clientes que confían en nosotros para el mantenimiento y reparación de su vehículo.
              </p>
              <p className="text-zinc-400 text-sm leading-relaxed font-light">
                Hoy combinamos la experiencia en mecánica tradicional con herramientas de diagnosis moderna,
                trabajos de electrónica y servicios como láminas de protección solar o reprogramaciones,
                siempre buscando que tu coche salga del taller mejor de lo que entró.
              </p>
            </div>

            {/* Highlights */}
            <div className="mt-8 grid grid-cols-2 gap-4">
              {[
                { icon: 'ri-map-pin-2-line', label: 'Ronda, Málaga', sub: 'Desde el primer día' },
                { icon: 'ri-tools-line', label: 'Mecánica completa', sub: 'Cualquier marca' },
                { icon: 'ri-search-eye-line', label: 'Diagnóstico moderno', sub: 'Tecnología avanzada' },
                { icon: 'ri-shield-check-line', label: 'Garantía total', sub: 'En todo trabajo' },
              ].map((h) => (
                <div key={h.label} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-yellow-400/10 border border-yellow-400/15 text-yellow-400 flex-shrink-0 mt-0.5">
                    <i className={`${h.icon} text-xs`} />
                  </div>
                  <div>
                    <p className="text-white text-xs font-bold">{h.label}</p>
                    <p className="text-zinc-600 text-xs">{h.sub}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Historia;
